export enum SubscribtionStatusEnum {
  Active = 1,
  Deactivated = 2,
  Expired = 3,
  ExpiredSoon = 4
}
